const WalletActionTypes = {
  // Fetch supported countries
  FETCH_COUNTRIES_START: "FETCH_COUNTRIES_START",
  FETCH_COUNTRIES_SUCCESS: "FETCH_COUNTRIES_SUCCESS",
  FETCH_COUNTRIES_FAILURE: "FETCH_COUNTRIES_FAILURE",

  // Update user location
  UPDATE_LOCATION_START: "UPDATE_LOCATION_START",
  UPDATE_LOCATION_SUCCESS: "UPDATE_LOCATION_SUCCESS",
  UPDATE_LOCATION_FAILURE: "UPDATE_LOCATION_FAILURE",

  // Fetch exchange rates
  FETCH_RATES_START: "FETCH_RATES_START",
  FETCH_RATES_SUCCESS: "FETCH_RATES_SUCCESS",
  FETCH_RATES_FAILURE: "FETCH_RATES_FAILURE",

  // Initialize deposit
  INIT_DEPOSIT_START: "INIT_DEPOSIT_START",
  INIT_DEPOSIT_SUCCESS: "INIT_DEPOSIT_SUCCESS",
  INIT_DEPOSIT_FAILURE: "INIT_DEPOSIT_FAILURE",

  // Verify Paystack payment
  VERIFY_PAYSTACK_PAYMENT_START: "VERIFY_PAYSTACK_PAYMENT_START",
  VERIFY_PAYSTACK_PAYMENT_SUCCESS: "VERIFY_PAYSTACK_PAYMENT_SUCCESS",
  VERIFY_PAYSTACK_PAYMENT_FAILURE: "VERIFY_PAYSTACK_PAYMENT_FAILURE",

  // Fetch deposit history
  FETCH_DEPOSITS_START: "FETCH_DEPOSITS_START",
  FETCH_DEPOSITS_SUCCESS: "FETCH_DEPOSITS_SUCCESS",
  FETCH_DEPOSITS_FAILURE: "FETCH_DEPOSITS_FAILURE",

  // Request withdrawal
  REQUEST_WITHDRAWAL_START: "REQUEST_WITHDRAWAL_START",
  REQUEST_WITHDRAWAL_SUCCESS: "REQUEST_WITHDRAWAL_SUCCESS",
  REQUEST_WITHDRAWAL_FAILURE: "REQUEST_WITHDRAWAL_FAILURE",

  // Fetch saved cards
  FETCH_CARDS_START: "FETCH_CARDS_START",
  FETCH_CARDS_SUCCESS: "FETCH_CARDS_SUCCESS",
  FETCH_CARDS_FAILURE: "FETCH_CARDS_FAILURE",

  // Fetch balance
  FETCH_BALANCE_START: "FETCH_BALANCE_START",
  FETCH_BALANCE_SUCCESS: "FETCH_BALANCE_SUCCESS",
  FETCH_BALANCE_FAILURE: "FETCH_BALANCE_FAILURE",

  // Clear messages
  CLEAR_WALLET_MESSAGES: "CLEAR_WALLET_MESSAGES",

  // Fetch wallet history (merged deposits & withdrawals)
  FETCH_WALLET_HISTORY_START: "FETCH_WALLET_HISTORY_START",
  FETCH_WALLET_HISTORY_SUCCESS: "FETCH_WALLET_HISTORY_SUCCESS",
  FETCH_WALLET_HISTORY_FAILURE: "FETCH_WALLET_HISTORY_FAILURE",

  // Stripe Connect
  CREATE_STRIPE_CONNECT_START: "CREATE_STRIPE_CONNECT_START",
  CREATE_STRIPE_CONNECT_SUCCESS: "CREATE_STRIPE_CONNECT_SUCCESS",
  CREATE_STRIPE_CONNECT_FAILURE: "CREATE_STRIPE_CONNECT_FAILURE",

  FETCH_STRIPE_CONNECT_STATUS_START: "FETCH_STRIPE_CONNECT_STATUS_START",
  FETCH_STRIPE_CONNECT_STATUS_SUCCESS: "FETCH_STRIPE_CONNECT_STATUS_SUCCESS",
  FETCH_STRIPE_CONNECT_STATUS_FAILURE: "FETCH_STRIPE_CONNECT_STATUS_FAILURE",
};

export default WalletActionTypes;
